/**
 * The custom gap two blocks offer beside their named gaps: the Carousel and
 * the Gallery. Set `gap="custom"` and the length comes from `gap-size`, in
 * whole pixels.
 *
 * One home for the limit and the reader, because the block CSS carries one
 * rule per whole pixel up to the limit (`custom-gap.ts` in
 * `@tripcart/page-builder`). A block whose panel offered more than that would
 * store a value no rule matches.
 */

export const CUSTOM_GAP = "custom";

export const CUSTOM_GAP_SIZE_MAX = 80;

export const CUSTOM_GAP_SIZE_ATTR = "gap-size";

/**
 * A stored size as whole pixels, clamped into range, or undefined when there
 * is none to read. Out-of-range sizes are clamped, not dropped: 120 means "as
 * loose as allowed".
 */
export const readCustomGapSize = (value: unknown): number | undefined => {
  if (value === undefined || value === null || value === "") return undefined;
  const n = Math.round(Number(value));
  if (!Number.isFinite(n)) return undefined;
  return Math.min(Math.max(n, 0), CUSTOM_GAP_SIZE_MAX);
};
